/* services */
import { rei } from "@/services/api"

/* helpers */
import { emptyToNull } from '@/helpers/object'

/* adapters */
import { getDadosEnviar } from '@/adapters/obitoAdapterEnviar'
import { getDadosReceber } from '@/adapters/obitoAdapterReceber'

/* libraries */
import moment from "moment"

class ObitoService {
  static getObitoById (obito_id) {
    return rei.get(`obitos/${obito_id}`).then(res => {
      const newObj = getDadosReceber(res.data)

      return newObj
    })
  }

  static storeObito (params) {
    params = emptyToNull(params)
    return rei.post(`inserir-obito`, { ...params }).then(res => res.data)
  }

  static updateObito (obito_id, params) {
    params = emptyToNull(params)

    const obj = getDadosEnviar(params)

    return rei.put(`obitos/${obito_id}`, { ...obj }).then(res => res.data)
  }

  static registrarObito (dados) {
    dados = emptyToNull(dados)

    const obj = getDadosEnviar(dados)

    return this.storeObito(obj)
  }

  static async editarObito (dados) {
    return await this.updateObito(dados.obito_id, dados)
  }

  static async carregarObito (obito_id, cartorio_id, registro_id, obitoData = null) {
    // TODO: rever necessidade desse método
    const obito = !obitoData ? await this.getObitoById(obito_id, cartorio_id, registro_id) : obitoData
    const { pessoa } = obito.registro

    const dados = {
      ...obito,
      ...pessoa,
      obito_id: obito.obito_id,
      codigo_ocupacao: pessoa.ocupacao,
      endereco: pessoa.endereco,
      genitores: pessoa.genitores,
      filhoDeixado: obito.filhoDeixado,
      partes: obito.registro.partes,
      documentos: pessoa.documentos,
      pessoa_id: pessoa.pessoa_id
    }

    dados.data_nascimento = dados.data_nascimento && moment(String(dados.data_nascimento), 'YYYY/MM/DD').format('DD/MM/YYYY')
    dados.data_obito = dados.data_obito && moment(String(dados.data_obito), 'YYYY/MM/DD').format('DD/MM/YYYY')

    return { obito, dados, obito_id: obito.obito_id }
  }
  
  static transporte (params) {
    return rei.post(`transporte-obito`, { ...params }).then(res => res.data)
  }
}

export default ObitoService
